import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const ECrowdCellFields = {
	id: 'id',
	ims: 'ims',
	isLinked: 'isLinked',
	mme: 'mme',
	page: 'page',
	pageSize: 'pageSize',
	searchValue: 'searchValue',
	searchField: 'searchField',
	siteId: 'siteId',
	sortDirection: 'sortDirection',
	sortFieldName: 'sortFieldName',
	status: 'status',
	systemId: 'systemId',
	firstSeen: 'firstSeenText',
	lastSeen: 'lastSeenText',
	gnodeBId: 'gnodeBId',
	enodeBId: 'enodeBId',
	lng: 'lng',
	lat: 'lat',
} as const;

export type TCrowdCellFields = TValueOfStringRecord<typeof ECrowdCellFields>

export const ESearchType = {
	nodeBid: 'nodeBId',
	siteId: 'siteId',
} as const;

export type TSearchType = TValueOfStringRecord<typeof ESearchType>
